interface FavoriteButtonProps {
  active: boolean;
  onToggle: () => void;
  size?: "sm" | "md" | "lg";
}

export default function FavoriteButton({ active, onToggle, size = "md" }: FavoriteButtonProps) {
  const sizing =
    size === "lg"
      ? "px-5 py-2.5 text-sm gap-2"
      : size === "sm"
        ? "px-3 py-1.5 text-xs gap-1.5"
        : "px-4 py-2 text-sm gap-2";

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={active}
      title="收藏状态保存在本地浏览器（演示功能）"
      className={[
        "flex cursor-pointer items-center whitespace-nowrap rounded-full border transition-colors",
        sizing,
        active
          ? "border-primary-500 bg-primary-500 text-background-50 hover:bg-primary-600"
          : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600",
      ].join(" ")}
    >
      <i className={active ? "ri-heart-3-fill" : "ri-heart-3-line"} />
      {active ? "已收藏" : "收藏"}
    </button>
  );
}